import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const items = [
  { key: 'urgence_1', icon: 'ri-ruler-line' },
  { key: 'urgence_2', icon: 'ri-sound-module-line' },
  { key: 'urgence_3', icon: 'ri-drop-line' },
  { key: 'urgence_4', icon: 'ri-error-warning-line' },
  { key: 'urgence_5', icon: 'ri-home-smile-line' },
];

export default function UrgenceExpliquee() {
  const { t } = useTranslation('deneigement');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="urgence" className="bg-blue-ice py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-white text-2xl md:text-3xl lg:text-4xl">
            {t('urgence_h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mb-10">
          {items.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-start gap-4 p-4 md:p-5 bg-white/15 rounded-xl backdrop-blur-sm transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 100 + 200}ms` }}
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-white/20">
                <i className={`${item.icon} text-white text-lg`} />
              </div>
              <span className="text-white font-medium text-sm pt-1 leading-snug">
                {t(item.key)}
              </span>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="tel:+14184769950"
            aria-label="Appeler Couvreur-Lévis.com au 418-476-9950"
            title="Cliquez pour appeler"
            className="inline-flex items-center gap-3 bg-white hover:bg-soft-gray text-slate-primary font-bold px-8 py-4 rounded-md text-base transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-phone-line text-blue-ice" />
            {t('cta_phone')} — {t('urgence_cta')}
          </a>
        </div>
      </div>
    </section>
  );
}